import { useGetDealQuery } from '../../graphql/__generated__/graphql.autogenerated'

const useCustomerDetails = (token?: string) => {
  const { data, loading, error } = useGetDealQuery({
    variables: {
      token: token || '',
    },
    skip: !token,
  })
  const customer = data?.deal?.customer || null
  const journeyType = data?.deal.journeyType || null

  return {
    loading,
    error,
    journeyType,
    customer,
  }
}

export default useCustomerDetails
